import { render, staticRenderFns } from "./MeasurementDiv.vue?vue&type=template&id=bd3df644&scoped=true&"
import script from "./MeasurementDiv.vue?vue&type=script&lang=ts&"
export * from "./MeasurementDiv.vue?vue&type=script&lang=ts&"
import style0 from "./MeasurementDiv.vue?vue&type=style&index=0&id=bd3df644&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3df644",
  null
  
)

export default component.exports